<template>
  <v-layout
    column
    class="style-form-image-settings"
  >
    <v-dialog persistent v-model="showChooseImageModal">
      <galleries-list
        modal-view
        @pickedImage="setImage"
      />
    </v-dialog>

    <h4
      v-if="title"
      class="mb-2"
    >
      {{ title }}
    </h4>

    <img
      class="style-form-image-settings__preview"
      @click="toggleModal"
      :src="value || PLACEHOLDER_PATH"
    />
  </v-layout>
</template>

<script>
import GalleriesList from '@/components/pages/Gallery/GalleriesList'

const PLACEHOLDER_PATH = '/static/image-placeholder.png'

export default {
  name: 'ImageSetting',
  components: {
    GalleriesList
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    value: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      PLACEHOLDER_PATH,
      showChooseImageModal: false
    }
  },
  methods: {
    setImage (url) {
      this.$emit('input', url.imagesUrls.originalImageUrl)
      this.toggleModal()
    },
    toggleModal () {
      this.showChooseImageModal = !this.showChooseImageModal
    }
  }
}
</script>

<style lang="scss">
.style-form-image-settings {
  &__preview {
    max-width: 600px;
    width: 100%;
    object-fit: contain;
    align-self: flex-start;
    margin-bottom: 30px;
    cursor: pointer;
  }
}
</style>




// WEBPACK FOOTER //
// src/components/pages/GeneralSettings/StylesSettings/styleSettingsFormComponents/ChooseImage.vue